function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import _ from 'lodash';
// eslint-disable-next-line import/no-unresolved
import { encodeQueryParams, useQueryParams } from 'use-query-params';
// See README.md for usage & API
export default function useQueryParamsHookFactory(config, defaults) {
    var _useQueryParams = _sliced_to_array(useQueryParams(_object_spread({}, config)), 2), allQueryParams = _useQueryParams[0], setAllQueryParams = _useQueryParams[1];
    var keys = _.keys(_object_spread({}, config));
    var scopedQueryParams = _.pick(allQueryParams, keys);
    // Update query params scoped to this hook factory and set them to new values
    // or clear the key (i.e. undefined) if it's being set to the default
    function handleSetScopedQueryParams(queryParamsToSet) {
        var newQueryParams = _.mapValues(_.pick(queryParamsToSet, keys), function(value, key) {
            return _.isEqual(value, defaults[key]) ? undefined : value;
        });
        setAllQueryParams(newQueryParams);
    }
    function pickParamsMinusDefaults(map) {
        return _.pickBy(map, function(_value, key) {
            return !_.isEqual(map[key], defaults[key]);
        });
    }
    // Take all query params, change one of them, remove anything that's set to its default value,
    // encode for usage with <Link>
    function handleGenerateScopedQueryParams(newKey, newValue) {
        if (_.includes(keys, newKey)) {
            var queryParamsToSet = _object_spread_props(_object_spread({}, scopedQueryParams), _define_property({}, newKey, newValue));
            var queryParamsToSetMinusDefaults = pickParamsMinusDefaults(queryParamsToSet);
            return encodeQueryParams(_object_spread({}, config), queryParamsToSetMinusDefaults);
        }
        console.error("handleGenerateScopedQueryParams on incorrect key ".concat(newKey, ", value: ").concat(newValue));
        return {};
    }
    function handleResetScopedQueryParams() {
        handleSetScopedQueryParams(defaults);
    }
    return {
        generateQueryParams: handleGenerateScopedQueryParams,
        queryParams: scopedQueryParams,
        queryParamsMinusDefaults: pickParamsMinusDefaults(scopedQueryParams),
        resetQueryParams: handleResetScopedQueryParams,
        setQueryParams: handleSetScopedQueryParams,
        defaults: defaults
    };
}
